module.exports = __webpack_public_path__ + "carousel-black-2.dca511c91552da18709ed2b91c49f78f.jpg";